import styled from "styled-components";
import IconPeragal from "../../Pages/images/Icon_Cropped.png";

export const FooterContainer = styled.footer`
  background: #101828;
  color: #cbd5e1;
  padding: 30px 18px;
`;

export const SocialMedia = styled.section`
  width: 100%;
`;

export const SocialMediaWrap = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;
  width: 100%;
  max-width: 980px;
  margin: 0 auto;

  @media screen and (max-width: 900px) {
    flex-direction: column;
  }
`;

export const SocialLogo = styled.div`
  color: #f8fafc;
  font-size: 1.1rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SocialIcon = styled.span`
  width: 30px;
  height: 30px;
  background: url(${IconPeragal}) center/contain no-repeat;
`;

export const WebsiteRights = styled.small`
  color: #98a2b3;
  text-align: center;
`;

export const SocialIcons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const SocialIconLink = styled.a`
  color: #cbd5e1;
  text-decoration: none;
  font-size: 0.95rem;

  &:hover {
    color: #93c5fd;
  }
`;